import { render, staticRenderFns } from "./rp-roles.vue?vue&type=template&id=af95293c"
import script from "./rp-roles.vue?vue&type=script&lang=js"
export * from "./rp-roles.vue?vue&type=script&lang=js"
import style0 from "./rp-roles.vue?vue&type=style&index=0&id=af95293c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports